/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exporting_Results_WaitInputs */



/**
* | output |
* | --- |
* | "Exporting results... please wait..." |
*
* @param {Exporting_Results_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const exporting_results_wait = /** @type {((inputs?: Exporting_Results_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exporting_Results_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation des résultats... veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ergebnisse werden exportiert... Bitte warten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione dei risultati... attendere prego...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт результатов... пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportando resultados... por favor espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("结果正在导出……请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("結果をエクスポートしています...お待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिणाम निर्यात किए जा रहे हैं... कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportando resultados... aguarde...")
	return /** @type {LocalizedString} */ ("Exporting results... please wait...")
});